import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Layers, ShoppingCart, Database, Globe, Cpu, Zap, Workflow, Lock, BarChart3, Heart } from 'lucide-react';

const EcommerceSolutions = () => {
  return (
    <section id="ecommerce-solutions" className="py-16 md:py-28">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Maßgeschneiderte E-Commerce Lösungen für 2025+
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            In der digitalen Handelswelt von 2025 entscheidet nicht nur die Plattform, sondern das Gesamterlebnis über deinen Erfolg.
            Wir entwickeln individuelle Shop-Ökosysteme, die genau auf deine Anforderungen zugeschnitten sind.
          </p>
          <p className="text-xs text-gray-500 mt-3">
            Unterstützt durch Technologien wie Shopware, eigene Entwicklungen oder Shopify – je nach deinen spezifischen Anforderungen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <Card className="bg-white border-0 hover:shadow-xl transition-all duration-300 overflow-hidden group">
            <CardContent className="p-0">
              <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-2"></div>
              <div className="p-6">
                <div className="rounded-full bg-blue-100 p-3 mb-4 group-hover:bg-blue-200 transition-colors">
                  <ShoppingCart className="h-7 w-7 text-blue-700" />
                </div>
                <h3 className="text-xl font-bold mb-3">B2C Shop Experience</h3>
                <p className="text-gray-600 mb-4">
                  Hochkonvertierende Endkunden-Shops mit emotionalem Design, personalisierten Erlebnissen und 
                  intuitiver Benutzerführung für maximale Conversion-Raten.
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-center gap-2">
                    <Heart size={16} className="text-pink-500" /> Emotional Design
                  </li>
                  <li className="flex items-center gap-2">
                    <BarChart3 size={16} className="text-green-500" /> Conversion-Optimierung
                  </li>
                  <li className="flex items-center gap-2">
                    <Cpu size={16} className="text-purple-500" /> KI-gestützte Produktempfehlungen
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-0 hover:shadow-xl transition-all duration-300 overflow-hidden group">
            <CardContent className="p-0">
              <div className="bg-gradient-to-br from-slate-50 to-blue-100 p-2"></div>
              <div className="p-6">
                <div className="rounded-full bg-blue-100 p-3 mb-4 group-hover:bg-blue-200 transition-colors">
                  <Database className="h-7 w-7 text-blue-700" />
                </div>
                <h3 className="text-xl font-bold mb-3">B2B Commerce Platform</h3>
                <p className="text-gray-600 mb-4">
                  Leistungsstarke B2B-Plattformen mit fortschrittlichem Kundenmanagement, individuellen Preisstrukturen 
                  und automatisierten Geschäftsprozessen.
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-center gap-2">
                    <Workflow size={16} className="text-blue-500" /> Komplexe Bestellprozesse
                  </li>
                  <li className="flex items-center gap-2">
                    <Lock size={16} className="text-slate-500" /> Berechtigungssystem
                  </li>
                  <li className="flex items-center gap-2">
                    <Zap size={16} className="text-amber-500" /> Nahtlose ERP-Integration
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-0 hover:shadow-xl transition-all duration-300 overflow-hidden group">
            <CardContent className="p-0">
              <div className="bg-gradient-to-br from-indigo-50 to-purple-100 p-2"></div>
              <div className="p-6">
                <div className="rounded-full bg-blue-100 p-3 mb-4 group-hover:bg-blue-200 transition-colors">
                  <Globe className="h-7 w-7 text-blue-700" />
                </div>
                <h3 className="text-xl font-bold mb-3">Omnichannel Commerce</h3>
                <p className="text-gray-600 mb-4">
                  Vernetzte Handelslösungen über alle Kanäle – vom Shop über Marktplätze bis zu Social Commerce 
                  und stationärem Handel mit einheitlicher Customer Journey.
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-center gap-2">
                    <Layers size={16} className="text-indigo-500" /> Multichannel-Synchronisation
                  </li>
                  <li className="flex items-center gap-2">
                    <BarChart3 size={16} className="text-green-500" /> Kanal-übergreifende Analysen
                  </li>
                  <li className="flex items-center gap-2">
                    <Cpu size={16} className="text-purple-500" /> Content-Automatisierung
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default EcommerceSolutions; 